import API from "../api/axios";

// ─── Get Lead Details ───
export const getLeadDetails = (id) => {
   return API.get(`/leads/${id}`);
};

// ─── Get Lead Followups ───
export const getLeadFollowups = (id) => {
   return API.get(`/followups/${id}`);
};

// ─── Get Lead Activities ───
export const getLeadActivities = (id) => {
   return API.get(`/leads/${id}/activities`);
};

// ─── Add Followup ───
export const addFollowup = (data) => {
   return API.post("/followups", data);
};